import React from 'react'
import printConfig from '../../../print-config.json'
import config from '../../../config.json'
import requestStatusConstants from "../../../constants/requestStatus";
import { Link } from 'react-router-dom';
import actionTypes from '../../../actions/actionTypes';
import { PreviewPrintButtons } from './FlyerButtons';
import FlyerSmallPagePreview from './FlyerSmallPagePreview';
import Translation from '../../Translation/cont/Translation';
import FlyerSettingsSection from './FlyerSettingsSection';
import FylerPreviewAll from './FylerPreviewAll';
import WrapperPageSpinner from '../../WrapperPage/present/WrapperPageSpinner';


const PrintFlyer = ({
    cinemaId,
    printID,
    printType,
    landscape,
    requestStatus,
    requestError,
    requestOverlay,
    activeWeek,
    hasChanges,
    features,
    flyerData,
    printFlyerRequest, 
    printUpdateRequest,
    basicUrl,
    closePagePath,
    onPrintFlyerPdfResetState,
    flyerSettings,
    updateFlyerSettings
}) => {
    if(!features) {
        return ''
    }

    const { requestType } = requestOverlay
    const { REQUEST_PENDING, REQUEST_SUCCESS, REQUEST_ERROR } = requestStatusConstants
    const isRequest =  actionTypes.PRINT_DATA_FLYER_PDF_REQUEST === requestType

    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })
    const currentPrintID = _.findKey(printConfig.formats, currentPrintFormat)

    let buttonTextTransId

    if(requestStatus === REQUEST_PENDING ) {
        buttonTextTransId = "print_flyer_is_generated"
    } else if(requestStatus === REQUEST_ERROR) {
        buttonTextTransId =  "error_button"
    } else {
        buttonTextTransId = "print_flyer_generate"
    }

    return (
        <WrapperPageSpinner
            pageTitle={[<Translation key="name_one" id={printConfig.routes[printType].transIdname} after={' / '}/>,<Translation id={'print_cw'} key="name_two" after={' ' + activeWeek + ''}/>]}
            closePagePath={closePagePath} 

        
            pending={isRequest && REQUEST_PENDING === requestStatus}
            error={isRequest && REQUEST_ERROR === requestStatus}
            success={isRequest && REQUEST_SUCCESS === requestStatus}
        
            pendingTextTransId='print_flyer_is_generated'
            errorTextTransId='print_flyer_error_occurred_while_generating'
            successTextTransId='print_flyer_PDF_successfully_generated'
        
            errorMsg={requestError ? requestError.message : ''}
            successMsg='Es befindet sich in dem Downloadordner oder ist über die Downloadhistorie des Browsers zu finden. Je nach Downloadeinstellung kann sich der Speicherort unterscheiden.'
        
            onClickSuccesButton={onPrintFlyerPdfResetState}
            onClickErrorButton={onPrintFlyerPdfResetState}
        >
            <div className="program-page program-page-sorting-movies flyer print-page site-content">
                {features.has_flyer ? (
                    <div className="selections-item">
                        <div className="selections-item-content accordion-item">
                            <div className="selections-item-selections section-left">
                                <div className="program-list film-content">
                                    <h3 className="gap-20 title-list text-regular"><Translation id="print_flyer_choose_editing_area">Bearbeitungsbereich wählen</Translation></h3>
                                    <div className="title-list gap-30 sides set-week-buttons">
                                        <div className='preview-and-button-container'>
                                            <div className="button-wrapper">
                                                <Link className='button button-text' to={`${basicUrl}/outside`}><p><Translation id="print_flyer_outside">Außenseite</Translation></p></Link>
                                            </div>
                                            <FlyerSmallPagePreview
                                                outside={true}
                                                side="outside"
                                                flyerStructureData={flyerData.flyerStructure}
                                            />
                                        </div>
                                        <div className='preview-and-button-container'>
                                            <div className="button-wrapper">
                                                <Link className='button button-text' to={`${basicUrl}/inside`}><p><Translation id="print_flyer_inside">Innenseite</Translation></p></Link>
                                            </div>
                                            <FlyerSmallPagePreview
                                                outside={false}
                                                side="inside"
                                                flyerStructureData={flyerData.flyerStructure}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="selections-item-selections section-right print-details">
                                <p className='gap-35'>
                                    <span className='text-regular-uppercase'><Translation id="print_flyer_execution">Ausführung</Translation></span><br/>
                                    <Translation id="print_flyer_landscape">Hochformat</Translation><br/><br/>
                                    <span className='text-regular-uppercase'><Translation id="print_flyer_closed_final_format">Geschlossenes Endformat</Translation></span><br/>
                                    <Translation id="print_flyer_DIN_long">DIN lang</Translation> (9,8 x 21 cm)<br/><br/>
                                    <span className='text-regular-uppercase'><Translation id="print_flyer_page_count">Seitenanzahl</Translation></span><br/>
                                    6<br/>
                                </p>
                                <FlyerSettingsSection 
                                    flyerSettings={flyerSettings}
                                    updateFlyerSettings={updateFlyerSettings}
                                />
                            </div>

                            <FylerPreviewAll
                                activeWeek={activeWeek}
                                printType={printType}
                                printFormat={printID}
                                landscape={landscapeBoolean}
                                flyerData={flyerData}
                                currentCinemaId={cinemaId}
                            />
                        </div>

                        <PreviewPrintButtons 
                            hasChanges={hasChanges}
                            buttonTextTransId={buttonTextTransId}
                            cinemaId={cinemaId}
                            printType={printType}
                            currentPrintID={currentPrintID}
                            printID={printID}
                            landscapeBoolean={landscapeBoolean}
                            activeWeek={activeWeek}
                            printUpdateRequest={printUpdateRequest}
                            printFlyerRequest={printFlyerRequest}
                        />
                    </div>
                ) : (
                    <div>Dieses Feature ist nicht freigeschaltet. Bei Interesse kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:info@pmkino.com">Support</a>.</div>
                )}
            </div>
        </WrapperPageSpinner>
    )
}

export default PrintFlyer

